import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import useTheme from '@mui/material/styles/useTheme';
// LAYOUT BASED HOOK
import useLayout from 'layouts/layout-1/context/useLayout';
// CUSTOM COMPONENTS
import Link from 'components/link';
import Scrollbar from 'components/scrollbar';
import FlexBetween from 'components/flexbox/FlexBetween';
import MultiLevelMenu from './MultiLevelMenu';
// import UserAccount from 'layouts/layout-parts/UserAccount';
// CUSTOM ICON COMPONENT
import ArrowLeftToLine from 'icons/duotone/ArrowLeftToLine';
// STYLED COMPONENTS
import { SidebarWrapper } from 'layouts/layout-1/styles';
// CUSTOM UTILS METHOD
import { isDark } from 'utils/constants';
const TOP_HEADER_AREA = 70;
export default function DashboardSidebar() {
  const theme = useTheme();
  const logoSrc = isDark(theme) ? '/static/logo/logo_white.png' : '/static/logo/logo.png';
  const { sidebarCompact, handleSidebarCompactToggle } = useLayout();
  const [onHover, setOnHover] = useState(false);

  // Preload both logos to prevent flickering
  useEffect(() => {
    const preloadImage = (src) => {
      const img = new Image();
      img.src = src;
    };
    preloadImage('/static/logo/logo.png');
    preloadImage('/static/logo/logo_white.png');
    preloadImage('/static/logo/logo1.png');
  }, []);

  // ACTIVATE COMPACT WHEN TOGGLE BUTTON CLICKED AND NOT ON HOVER STATE
  const COMPACT = sidebarCompact && !onHover ? 1 : 0;
  return (
    <SidebarWrapper
      compact={sidebarCompact ? 1 : 0}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => sidebarCompact && setOnHover(false)}
    >
      <FlexBetween padding="1.5rem 1rem .5rem 2.3rem" height={TOP_HEADER_AREA}>
        {/* LOGO */}
        <Link
          href="/"
          style={{
            marginLeft: '-8px',
            position: 'relative',
            display: 'inline-block'
          }}
        >
          {/* Full logo */}
          <Box
            component="img"
            src={logoSrc}
            alt="logo"
            width={120}
            sx={{
              height: 'auto',
              objectFit: 'contain',
              opacity: COMPACT ? 0 : 1,
              position: 'absolute',
              top: 0,
              left: 0
              // transition: 'opacity 0.15s ease-in-out'
            }}
          />
          {/* Compact logo */}
          <Box
            component="img"
            src="/static/logo/logo1.png"
            alt="logo"
            width={30}
            sx={{
              height: 'auto',
              objectFit: 'contain',
              opacity: COMPACT ? 1 : 0
              // transition: 'opacity 0.15s ease-in-out'
            }}
          />
        </Link>

        {/* SIDEBAR COLLAPSE BUTTON */}
        {!COMPACT ? (
          <IconButton onClick={handleSidebarCompactToggle}>
            <ArrowLeftToLine sx={{ rotate: sidebarCompact ? '180deg' : 0 }} />
          </IconButton>
        ) : null}
      </FlexBetween>

      <Scrollbar
        autoHide
        clickOnTrack={false}
        sx={{
          overflowX: 'hidden',
          maxHeight: `calc(100vh - ${TOP_HEADER_AREA}px)`
        }}
      >
        <Box height="100%" px={2}>
          {/* NAVIGATION ITEMS */}
          <MultiLevelMenu sidebarCompact={!!COMPACT} />

          {/* USER ACCOUNT INFO */}
          {/*{!COMPACT ? <UserAccount /> : null}*/}
        </Box>
      </Scrollbar>
    </SidebarWrapper>
  );
}
